import React from "react";
import "../Assets/css/index.css";

function TermsAndConditions() {
  return <div>TermsAndConditions</div>;
}

export default TermsAndConditions;
  